(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content_tabs"] && !Shopify.designMode) return;
  try {
    
  
tabs = document.querySelectorAll('.tab');
tabContents = document.querySelectorAll('.tab-content');

tabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content){
      content.classList.remove('active');
    });
    tabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});


mobileTabs = document.querySelectorAll('.mobile-tab');

mobileTabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    mobileTabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');

    document.querySelectorAll('.mobile-tab-content').forEach(function(content){
      content.style.display = 'none';
    });

    content.style.display = 'block';
  });
});


 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instruction-tabs"] && !Shopify.designMode) return;
  try {
    
  
tabs = document.querySelectorAll('.tab');
tabContents = document.querySelectorAll('.tab-content');

tabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    tabContents.forEach(function(content){
      content.classList.remove('active');
    });
    tabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');
    content.classList.add('active');
  });
});


mobileTabs = document.querySelectorAll('.mobile-tab');

mobileTabs.forEach(function(tab){
  tab.addEventListener('click', function(){
    contentId = this.dataset.contentId;
    content = document.getElementById(contentId);

    mobileTabs.forEach(function(tab){
      tab.classList.remove('active');
    });

    this.classList.add('active');

    document.querySelectorAll('.mobile-tab-content').forEach(function(content){
      content.style.display = 'none';
    });

    content.style.display = 'block';
  });
});


 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-blog"]) return;
  try {
    
  if (!customElements.get('blog-journal')) {
    customElements.define('blog-journal', class BlogJournal extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.blogUrl = this.dataset.blogUrl;

        this.searchInput = this.querySelector('[data-blog-search]');
        this.tagButtons = this.querySelectorAll('[data-tag-btn]');
        this.contentWrapper = this.querySelector('[data-blog-content]');
        this.loader = this.querySelector('[data-blog-loader]');

        this.activeTag = 'all';
        this.searchQuery = this.searchInput && this.searchInput.value ? this.searchInput.value.trim() : '';
        this.searchTimeout = null;
        this.abortController = null;

        this.initListeners();
      }

      initListeners() {
        if (this.searchInput) {
          this.searchInput.addEventListener('input', this.handleSearch.bind(this));
        }

        if (this.tagButtons) {
          this.tagButtons.forEach(button => {
            button.addEventListener('click', this.handleTagClick.bind(this));
          });
        }

        // Handle clicks on pagination links via AJAX
        this.addEventListener('click', (event) => {
          const paginationLink = event.target.closest('[data-blog-pagination] a');
          if (paginationLink) {
            event.preventDefault();
            this.fetchResults(paginationLink.href);
          }
        });
      }

      handleSearch(event) {
        clearTimeout(this.searchTimeout);
        const query = event.target.value.trim();

        this.searchTimeout = setTimeout(() => {
          this.searchQuery = query;
          this.fetchResults();
        }, 300);
      }

      handleTagClick(event) {
        const clickedButton = event.currentTarget;
        const selectedTag = clickedButton.getAttribute('data-tag');

        if (this.activeTag === selectedTag) return;

        this.tagButtons.forEach(button => button.classList.remove('is-active'));
        clickedButton.classList.add('is-active');

        this.activeTag = selectedTag;
        this.fetchResults();
      }

      buildFetchUrl(overrideUrl = null) {
        if (overrideUrl) {
          const url = new URL(overrideUrl, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);
          return url.toString();
        }

        let targetUrl;

        if (this.searchQuery) {
          // Global search endpoint for articles across the entire store/blog
          targetUrl = new URL('/search', window.location.origin);
          targetUrl.searchParams.set('type', 'article');
          
          let q = this.searchQuery;
          if (this.activeTag && this.activeTag !== 'all') {
            q += ` tag:${this.activeTag}`;
          }
          targetUrl.searchParams.set('q', q);
        } else {
          // Native Shopify tag filtering route
          let basePath = this.blogUrl;
          if (this.activeTag && this.activeTag !== 'all') {
            basePath += `/tagged/${this.activeTag}`;
          }
          targetUrl = new URL(basePath, window.location.origin);
        }

        targetUrl.searchParams.set('section_id', this.sectionId);
        return targetUrl.toString();
      }

      async fetchResults(overrideUrl = null) {
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();

        this.setLoading(true);

        const url = this.buildFetchUrl(overrideUrl);

        try {
          const response = await fetch(url, { signal: this.abortController.signal });
          const text = await response.text();

          const parser = new DOMParser();
          const html = parser.parseFromString(text, 'text/html');

          const newContent = html.querySelector('[data-blog-content]');
          
          if (newContent && this.contentWrapper) {
            this.contentWrapper.innerHTML = newContent.innerHTML;
          }

          const cleanUrl = new URL(url);
          cleanUrl.searchParams.delete('section_id');
          window.history.replaceState({}, '', cleanUrl.toString());

        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Error fetching blog articles:', error);
          }
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        const grid = this.querySelector('[data-blog-grid]');
        const loader = this.querySelector('[data-blog-loader]');

        if (isLoading) {
          if (grid) grid.classList.add('is-loading');
          if (loader) loader.classList.remove('is-hidden');
        } else {
          if (grid) grid.classList.remove('is-loading');
          if (loader) loader.classList.add('is-hidden');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sortSelect = document.getElementById('CustomSortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', function (e) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', e.target.value);
        window.location.href = currentUrl.toString();
      });
    }

    const filterBtn = document.querySelector('.js-filter-toggle');
    const filterDrawer = document.querySelector('.js-filter-drawer');
    if (filterBtn && filterDrawer) {
      filterBtn.addEventListener('click', function () {
        filterDrawer.classList.toggle('is-open');
      });
    }

    const priceContainers = document.querySelectorAll('.js-price-range-container');
    priceContainers.forEach(function (container) {
      const rangeMin = container.querySelector('.js-range-min');
      const rangeMax = container.querySelector('.js-range-max');
      const rangeProgress = container.querySelector('.js-range-progress');
      const inputMin = container.querySelector('.js-input-min');
      const inputMax = container.querySelector('.js-input-max');
      const displayMin = container.querySelector('.js-display-min');
      const displayMax = container.querySelector('.js-display-max');
      const filterForm = container.closest('form');

      if (!rangeMin || !rangeMax) return;

      const maxVal = parseFloat(rangeMin.getAttribute('max')) || 100;

      function updateSlider() {
        let minCurrent = parseFloat(rangeMin.value);
        let maxCurrent = parseFloat(rangeMax.value);

        if (minCurrent > maxCurrent) {
          const temp = minCurrent;
          minCurrent = maxCurrent;
          maxCurrent = temp;
        }

        const minPercent = (minCurrent / maxVal) * 100;
        const maxPercent = (maxCurrent / maxVal) * 100;

        if (rangeProgress) {
          rangeProgress.style.left = minPercent + '%';
          rangeProgress.style.width = maxPercent - minPercent + '%';
        }

        if (displayMin) displayMin.textContent = minCurrent;
        if (displayMax) displayMax.textContent = maxCurrent;

        if (inputMin) inputMin.value = minCurrent;
        if (inputMax) inputMax.value = maxCurrent;

      }

      rangeMin.addEventListener('input', updateSlider);
      rangeMax.addEventListener('input', updateSlider);

      rangeMin.addEventListener('change', function () {
        if (filterForm) filterForm.submit();
      });
      rangeMax.addEventListener('change', function () {
        if (filterForm) filterForm.submit();
      });

      updateSlider();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // Helper method to detect if device screen is desktop size
    isDesktop() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Always sticky behavior on Desktop
      if (this.isDesktop()) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
          this.header.classList.remove('shopify-section-header-hidden');
        } else {
          this.header.classList.remove('shopify-section-header-sticky', 'scrolled-past-header', 'shopify-section-header-hidden');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // Scroll-up sticky behavior on Mobile
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isDesktop()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.isDesktop()) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.isDesktop()) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-slider')) {
    customElements.define(
      'testimonial-slider',
      class TestimonialSlider extends HTMLElement {
        constructor() {
          super();
          this.track = this.querySelector('[data-slider-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
          this.prevBtn = this.querySelector('[data-slider-prev]');
          this.nextBtn = this.querySelector('[data-slider-next]');
          this.dotsContainer = this.querySelector('[data-slider-dots]');

          this.currentIndex = 0;
          this.init();
        }

        init() {
          if (!this.track || this.slides.length === 0) return;

          this.updateMetrics();
          this.createDots();
          this.updateSlider();

          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.slidePrev());
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.slideNext());

          window.addEventListener('resize', () => {
            this.updateMetrics();
            this.createDots();
            this.updateSlider();
          });
        }

        updateMetrics() {
          const width = window.innerWidth;
          if (width >= 990) {
            this.visibleColumns = parseInt(this.dataset.columnsDesktop || '3', 10);
          } else if (width >= 750) {
            this.visibleColumns = parseInt(this.dataset.columnsTablet || '2', 10);
          } else {
            this.visibleColumns = parseInt(this.dataset.columnsMobile || '1', 10);
          }

          this.maxIndex = Math.max(0, this.slides.length - this.visibleColumns);
        }

        createDots() {
          if (!this.dotsContainer) return;
          this.dotsContainer.innerHTML = '';

          const totalDots = this.maxIndex + 1;
          if (totalDots <= 1) return;

          for (let i = 0; i < totalDots; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.classList.add('testimonial-slider__dot');
            if (i === this.currentIndex) dot.classList.add('is-active');
            dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
            dot.addEventListener('click', () => {
              this.currentIndex = i;
              this.updateSlider();
            });
            this.dotsContainer.appendChild(dot);
          }
        }

        slidePrev() {
          if (this.currentIndex > 0) {
            this.currentIndex--;
          } else {
            this.currentIndex = this.maxIndex;
          }
          this.updateSlider();
        }

        slideNext() {
          if (this.currentIndex < this.maxIndex) {
            this.currentIndex++;
          } else {
            this.currentIndex = 0;
          }
          this.updateSlider();
        }

        updateSlider() {
          if (this.currentIndex > this.maxIndex) {
            this.currentIndex = this.maxIndex;
          }

          const firstSlide = this.slides[0];
          if (!firstSlide) return;

          const slideWidth = firstSlide.getBoundingClientRect().width;
          const style = window.getComputedStyle(this.track);
          const gap = parseFloat(style.gap) || 0;

          const moveAmount = (slideWidth + gap) * this.currentIndex;
          this.track.style.transform = `translateX(-${moveAmount}px)`;

          const dots = Array.from(this.dotsContainer?.children || []);
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === this.currentIndex);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelector('.background-video img').setAttribute('loading', 'lazy'); 
document.querySelector('.background-video img').setAttribute('fetchpriority', 'low'); 
document.querySelector('.background-video img').setAttribute('decoding', 'async'); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-darl-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelector('.background-video img').setAttribute('loading', 'lazy'); 
document.querySelector('.background-video img').setAttribute('fetchpriority', 'low'); 
document.querySelector('.background-video img').setAttribute('decoding', 'async'); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const timelineContainers = document.querySelectorAll('.js-timeline-container');

    timelineContainers.forEach(function (container) {
      const slides = container.querySelectorAll('.js-timeline-slide');
      const points = container.querySelectorAll('.js-timeline-point');
      const prevBtn = container.querySelector('.js-timeline-prev');
      const nextBtn = container.querySelector('.js-timeline-next');
      let currentIndex = 0;

      function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        slides.forEach(function (slide, i) {
          if (i === index) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });

        points.forEach(function (point, i) {
          if (i === index) {
            point.classList.add('is-active');
          } else {
            point.classList.remove('is-active');
          }
        });

        currentIndex = index;
      }

      points.forEach(function (point) {
        point.addEventListener('click', function () {
          const index = parseInt(this.getAttribute('data-index'), 10);
          goToSlide(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex + 1);
        });
      }
    });
  });

  document.addEventListener('shopify:block:select', function (e) {
    const selectedBlock = e.target;
    if (selectedBlock && selectedBlock.classList.contains('js-timeline-slide')) {
      const container = selectedBlock.closest('.js-timeline-container');
      if (container) {
        const index = parseInt(selectedBlock.getAttribute('data-index'), 10);
        const slides = container.querySelectorAll('.js-timeline-slide');
        const points = container.querySelectorAll('.js-timeline-point');

        slides.forEach(function (slide, i) {
          if (i === index) slide.classList.add('is-active');
          else slide.classList.remove('is-active');
        });

        points.forEach(function (point, i) {
          if (i === index) point.classList.add('is-active');
          else point.classList.remove('is-active');
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text-old"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  var previewImages = document.querySelectorAll('.video-preview');
  var videoPopups = document.querySelectorAll('.video-popup');
  var closeBtns = document.querySelectorAll('.close-btn');
  var videoElements = document.querySelectorAll('.video-element');

  previewImages.forEach(function(previewImage, index) {
    previewImage.addEventListener('click', function() {
      videoPopups[index].style.display = 'block';
      previewImage.style.display = 'none';
      videoElements[index].currentTime = 0;
      videoElements[index].muted = true; // Ensure muted for autoplay
      videoElements[index].play();
    });
  });

  closeBtns.forEach(function(closeBtn, index) {
    closeBtn.addEventListener('click', function() {
      videoPopups[index].style.display = 'none';
      previewImages[index].style.display = 'block';
      videoElements[index].pause();
    });
  });

  // Additional event listener for closing video popup on background click
  window.addEventListener('click', function(event) {
    videoPopups.forEach(function(videoPopup, index) {
      if (event.target == videoPopup) {
        videoPopup.style.display = 'none';
        previewImages[index].style.display = 'block';
        videoElements[index].pause();
      }
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    // Get all video preview images
    var videoPreviews = document.querySelectorAll('.video-preview');

    videoPreviews.forEach(function (preview, index) {
        // Assign unique IDs to each video popup and overlay
        var videoPopupId = 'videoPopup-' + index;
        var overlayId = 'overlay-' + index;
        var closeVideoId = 'closeVideo-' + index;
        var videoElementId = 'videoElement-' + index;

        // Create video popup and overlay elements
        var videoPopup = document.createElement('div');
        videoPopup.classList.add('video-popup');
        videoPopup.id = videoPopupId;
        videoPopup.innerHTML = `
            <span class="close-btn" id="${closeVideoId}">&times;</span>
            <video controls muted id="${videoElementId}" controlsList="nodownload">
                <source src="${preview.dataset.videoUrl}" type="video/mp4" />
            </video>
        `;

        var overlay = document.createElement('div');
        overlay.classList.add('overlay');
        overlay.id = overlayId;

        // Append the new elements to the body
        document.body.appendChild(videoPopup);
        document.body.appendChild(overlay);

        // Add event listener to the preview image
        preview.addEventListener('click', function () {
            document.getElementById(videoPopupId).style.display = 'block';
            document.getElementById(overlayId).style.display = 'block';
            document.getElementById(videoElementId).play(); // Play the video
        });

        // Add event listener to the close button
        document.getElementById(closeVideoId).addEventListener('click', function () {
            document.getElementById(videoPopupId).style.display = 'none';
            document.getElementById(overlayId).style.display = 'none';
            document.getElementById(videoElementId).pause();
        });

        // Add event listener to the overlay
        document.getElementById(overlayId).addEventListener('click', function () {
            document.getElementById(videoPopupId).style.display = 'none';
            document.getElementById(overlayId).style.display = 'none';
            document.getElementById(videoElementId).pause();
        });
    });
});


  } catch(e) { console.error(e); }
})();
})();
